"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.MinimizeMaximizeButton = ({ activeConversionBlockIdx, toggle, }) => {
    return (react_1.default.createElement(react_2.OsmosysButton, { osysName: activeConversionBlockIdx
            ? 'EmailCanvasConverterPanel.Toolbar.minimize'
            : 'EmailCanvasConverterPanel.Toolbar.maximize', color: "link", tooltip: activeConversionBlockIdx ? 'Minimize' : 'Open', className: "px-1", osysIcon: activeConversionBlockIdx ? 'minimize' : 'maximize', onClick: toggle }));
};
//# sourceMappingURL=MinimizeMaximizeButton.js.map